import { render, staticRenderFns } from "./AgricultureRelatedSubsidies.vue?vue&type=template&id=00a5457e&scoped=true"
import script from "./AgricultureRelatedSubsidies.vue?vue&type=script&lang=js"
export * from "./AgricultureRelatedSubsidies.vue?vue&type=script&lang=js"
import style0 from "./AgricultureRelatedSubsidies.vue?vue&type=style&index=0&id=00a5457e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5457e",
  null
  
)

export default component.exports